export const ROUTER_CLIENT = {
    HOME: "/",
    PRODUCT_LIST: "/products",
    PRODUCT_DETAIL: "/products/:slug",
    SEARCH_PAGE: "/search",
    POLICY_PAGE: "/policy"
}